import { useRegistryStore } from '@/stores/registry.store'
import { useWebSiteStore } from '@/stores/web-site.store'

export const useUnitOfMeasureService = () => {
  const webSiteStore = useWebSiteStore()
  const registryStore = useRegistryStore()

  const safeFindRatio = (key, predicate) => {
    const list = webSiteStore.unitConversions[key]
    const item = list?.find(predicate)

    if (item?.ratio != null) {
      return item.ratio
    }

    if (key === webSiteStore.unitOfMeasureOfTimeEnum.HR) {
      return 60
    }

    const hrUoM = webSiteStore.unitsOfMeasure.find(uom => uom.code === webSiteStore.unitOfMeasureOfTimeEnum.HR)
    if (hrUoM && predicate({ id: hrUoM.id })) {
      return 1 / 60
    }

    return 1
  }

  const getConversionRatio = (oldUoMId, newUoMId, supplier_brand_ref = null) => {
    if (!oldUoMId) return 1

    const ulUoM = webSiteStore.unitsOfMeasure.find(uom => uom.code === webSiteStore.unitOfMeasureOfTimeEnum.UL)
    const oldUoM = webSiteStore.unitsOfMeasure.find(uom => uom.id === oldUoMId)

    if (!supplier_brand_ref || (oldUoMId !== ulUoM.id && newUoMId !== ulUoM.id)) {
      return safeFindRatio(oldUoM.code, i => i.id === newUoMId)
    }

    const supplierBrandCode = registryStore.supplierBrands.find(i => i.id === supplier_brand_ref)?.code
    if (!supplierBrandCode) return 1

    if (oldUoMId === ulUoM.id) {
      // from UL_(brand) to UoM
      return safeFindRatio(`UL_${supplierBrandCode}`, i => i.id === newUoMId)
    }

    // from UoM to UL_(brand)
    return safeFindRatio(oldUoM.code, i => i.code === `UL_${supplierBrandCode}`)
  }

  return {
    getConversionRatio,
  }
}
